import React, { useState } from 'react'
import MenuIcon from "../../assets/img/icons/menu-responsive.svg"
import login from "../../assets/img/icons/login.svg"
import logo from "../../assets/img/Logo/logo.svg";
import SearchInput from '../shared/SearchInput';
import shoppingCard from "../../assets/img/icons/shopping-bag.svg";
import HamberburgerMenu from './HamberburgerMenu';


const ResponsiveMenu = () => {
  const [close, setclose] = useState(false)

  return (
    <div className='ResponsiveMenu'>
       <HamberburgerMenu setclose={setclose} close={close}/>

        <div className='container'>
         <div className='ResponsiveMenu--container'>
         <img className=' cursor-pointer' onClick={()=>setclose(true)} src={MenuIcon}/>
            <img src={logo}/>
            <img src={login}/>

            
         </div>
         <hr className='my-[20px]'/>
         <div className='ResponsiveMenu--container pb-[20px]'>
             <SearchInput/>
             <div className='ResponsiveMenu__shoppingcard center '>
                 <img src={shoppingCard} width={12}/>
                 <div className='ResponsiveMenu__shoppingcard-count Danafont'>0</div>
             </div>

            
         </div>
        </div>
    </div>
  )
}

export default ResponsiveMenu